// Angular
import { 
	Component,
	Input,
	OnInit
} from '@angular/core';
// Services
import { RulesChangeService } from '../../services/rules-change.service';
// Models
import { RulesEvents } from '../../models/inline-rules.event';

@Component({
	selector: 'cv-view-invision-rule-comments-component',
	templateUrl: './rule-comment-stip-view-item.component.html',
	styleUrls: ['./rule-comment-stip-view-item.component.scss']
})
export class RuleCommentStipViewItemComponent implements OnInit {
	@Input() item: any;
	@Input() type: string;
	@Input() path;
	@Input() activeActions = false;

	public isLargeItem = false;
	public viewMore = false;
	public text: string;

	constructor(private rulesChangeService: RulesChangeService) {
		//
	}

	ngOnInit(): void {
		this.text = this.item['note'] || this.item['stipulation'];

		if (this.text.length > 420) {
			this.isLargeItem = true;
		}
	}

	/**
	 * On toggle view more.
	 */
	public toggleViewMore(): void {
		this.viewMore = !this.viewMore;
	}

	/**
	 * Delete an item(comment/stip) from the Rule
	 * @param item
	 */
	public onDeleteItem(item: any): void {
		const data = {
			type: RulesEvents.DELETE_COMMENT,
			item: item,
			path: this.path
		}

		if (this.type === 'stip') {
			data.type = RulesEvents.DELETE_STIP
		}
		
		this.rulesChangeService.rulesDataChanged.next(data);
	}
}
